/**
 * Community links — configurable via env vars.
 * If REACT_APP_DISCORD_URL is not set, the button shows a "Coming soon" state.
 */
export const DISCORD_URL = process.env.REACT_APP_DISCORD_URL || "";
export const DISCORD_AVAILABLE = !!DISCORD_URL;
export const DISCORD_LABEL = DISCORD_AVAILABLE ? "Rejoindre le Discord" : "Discord — Bientôt";
